import {Tooltip} from 'bootstrap'

export default {
	methods: {
		initToolTip(selector) {
			this.$nextTick(() => {
				this.$el.querySelectorAll(`.${selector}`).forEach(el => {
					new Tooltip(el)
				})
			})
		}
	}
}
